import React, { useState, useMemo, useRef, useEffect } from "react";
import { Button, Input, Space, Typography, Drawer, Form, Select, Row, Col, notification } from "antd";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { ConverterConfigGrid } from "../../../../../../Common/UIConstants";
import DashMeters from "../DashMeters/DashMeters";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";

const { Search } = Input;

const DashConverters = () => {
  const [drawerOpen, setDrawerOpen2] = useState(false);
  const [form] = Form.useForm();
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [rowData, setRowData] = useState([]);
  const mode = useSelector((state) => state.darkMode);
  const [isloading, setISLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);
  const { isdarkMode } = mode;
  const [selectedMeterID, setSelectedMeterID] = useState(null);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const [modules, setModules] = useState([]);
  const [filteredData, setFilteredData] = useState(rowData);
  const [excelImage, setExcelImage] = useState(null);
  const loggedIn = useSelector((state) => state.user);
    const [meterSuppliers, setMeterSupplier] = useState([]);
  const [meterdetail, setMeterdetails] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [baudrate, setBaudrate] = useState([]);
  const [parity, setParity] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
const [editingRecord, setEditingRecord] = useState(null);


  // console.log(loggedIn)
  useEffect(() => {
    setExcelImage(
      loggedIn?.images?.excelImage
        ? `data:image/png;base64,${loggedIn?.images?.excelImage}`
        : null
    );
  }, [loggedIn]);

  const handleSearch = (value) => {
    const fullQuery = value.trim().toLowerCase(); // full string
    const queryChars = fullQuery.split("");
    //console.log(fullQuery)
    //console.log(queryChars)

    const result = rowData.filter((item) =>
      Object.values(item).some((field) => {
        const fieldStr = String(field ?? "").toLowerCase();
        //console.log(fieldStr)
        return fieldStr.includes(fullQuery);
        // ||                      // match full string
        // queryChars.some((char) => fieldStr.includes(char))   // OR match any char
      })
    );
    //console.log(result)

    setFilteredData(result);
  };

  useEffect(() => {
    setTimeout(() => {
      setISLoading(false);
    }, 2000);
  }, []);
  useEffect(() => {
    const savedValue = localStorage.setItem("selectedSiteID", selectedMeterID);
    //console.log(savedValue);
  }, [selectedMeterID]);

  const handleNotification = (msg) => {
    notification.open({
      message: msg,
      type: msg.includes("successfully") ? "success" : "success",
      placement: "topRight",
      duration: 3,
    });
  };

  const getReponse = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    })
      .then((res) => {
        //console.log("Converter:", res);
        if (res && res.length) {
          setRowData(res);
          setFilteredData(res);
        }
      })
      .catch((err) => {
        handleNotification("Error fetching data");
      });
  };

  const refetchData = () => {
    getReponse();
  };

  useEffect(() => {
    getReponse();
  }, [refetch]);

  const handleDeleteSubmit = (siteID) => {
    try {
      makeRequest({
        type: APIConstants.DELETE,
        url: `${APIConstants.DELETE_CONFIG_CONVERTER}?SITEID=${siteID}&IsDelete=true`,
      })
        .then((res) => {
          if (res) {
            const updatedRowData = rowData.filter(
              (item) => item.siteID !== siteID
            );
            setRowData(updatedRowData);
            setRefetch(!refetch);

            handleNotification("Converter successfully deleted!");
          }
        })
        .catch((error) => {
          //console.error(error);
          handleNotification("An error occurred while deleting the converter.");
        });
    } catch (err) {
      //console.error(err);
      handleNotification(
        "An unexpected error occurred while deleting the converter."
      );
    }
  };

  const openDrawer = () => setDrawerOpen2(true);
 const closeDrawer = () => {
  form.resetFields();
  setIsEditMode(false);
  setEditingRecord(null);
  setDrawerOpen2(false);
};


const onFinish = (values) => {
  if (isEditMode) {
    updateGroup(values);
  } else {
    insertGroup(values);
  }

  form.resetFields();
  closeDrawer();
};

const updateGroup = (formValues) => {
  console.log(formValues)
  const body = {
    converterID: editingRecord.siteID,
    converterName: formValues.converterName,
    converterIP: formValues.converterIP,
    port: String(formValues.port),
    noofports: formValues.noofPorts,
    moduleType: formValues.converterType.join(","),
    supplier: formValues.meterSupplier,
    supplierModel: formValues.metermodel,
    baudRate: formValues.baudrate,
    parity: formValues.parity,
  };
  console.log(body)

  makeRequest({
    type: APIConstants.POST, // or POST if backend expects
    url: APIConstants.CONFIG_UPDATE_CONVERTER,
    body,
  })
    .then((res) => {
      setRefetch(!refetch);
      handleNotification(res?.message || "Converter updated successfully");
    })
    .catch(() => {
      handleNotification("Error updating converter");
    });
};


  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`,
    }).then((res) => {
      if (res && res.length) {
        setModules(res);
      }
      //console.log("Get Modules :", res);
    });
  };

  useEffect(() => {
    getModules();
  }, []);

  const insertGroup = (formValues) => {
    console.log(formValues);
    const body = {
      converterID: formValues.converterID,
      converterName: formValues.converterName,
      converterIP: formValues.converterIP,
      port: formValues.port,
      noofports: formValues.noofPorts,
      moduleType: formValues.converterType.join(','),
      supplier: formValues.meterSupplier.value|| 1,
    supplierModel: formValues.metermodel||'LG5120D',
    baudRate:formValues.baudrate|| 8,
    parity: formValues.parity||1
    };
    console.log(body);
    const url = `${APIConstants.CONFIG_INSERT_CONVERTER}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    })
      .then((res) => {
        //console.log(res);
        setRefetch(!refetch);
        if (res && res.message) {
          // handleNotification("Converter successfully saved!", "success");
          handleNotification(res.message, "success");
        }
        // if (res ) {
        //   handleNotification("Converter successfully saved!", "success");
        //   // handleNotification(res.message,"success");
        //   setRefetch(!refetch)
        // }
      })
      .catch((err) => {
        //console.error(err);
        handleNotification(
          "An error occurred while saving the converter.",
          "error"
        );
      });
  };


  const getImageBufferFromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  };


const converterExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Converters");

  //   Step 1: Merge cells A1:B2 for the logo area
  worksheet.mergeCells("A1:B2");

  //   Step 2: Add logo with smaller size
  const imageUrl = excelImage ? excelImage : minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(imageUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.1 },
    ext: { width: 100, height: 37 },
  });

  //   Step 3: Add Title "Converter Detail" in next row (row 3)
  worksheet.mergeCells("A3:K3"); // Merge across all columns (adjust if needed)
  const titleCell = worksheet.getCell("A3");
  titleCell.value = "Converter Detail";
  titleCell.font = { size: 14, bold: true };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };

  //   Step 4: Header row at row 4
  const headerRowIndex = 4;
  const headers = [
    "S. No.",
    "Converter Name",
    "Converter ID",
    "IP Address",
    "Port",
    "No. of Ports",
    "Electrical",
    "Temperature",
    "Air",
    "Steam",
    "Water",
  ];
  worksheet.insertRow(headerRowIndex, headers);

  //   Step 5: Style header row
  const headerRow = worksheet.getRow(headerRowIndex);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" }, // Green
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" }, // White
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  //   Step 6: Add data rows starting from row 5
  const dataStartRow = headerRowIndex + 1;
  data.forEach((item, index) => {
    const row = worksheet.addRow([
      index + 1,
      item.siteName,
      item.siteID,
      item.siteIP ?? "",
      item.port,
      item.noofPorts,
      item.isElectrical,
      item.isTemperature,
      item.isAir,
      item.isSteam,
      item.isWater,
    ]);

    // Add borders to each data cell
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  //   Step 7: Auto-fit column widths based on longest content
  worksheet.columns.forEach((column, i) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const columnLength = cell.value ? cell.value.toString().length : 0;
      if (columnLength > maxLength) {
        maxLength = columnLength;
      }
    });
    column.width = maxLength < 10 ? 10 : maxLength + 2; // min 10 width, +2 padding
  });

  //   Step 8: Save file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Converters.xlsx");
};



  const meterSupplier = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_DEVICES_DETAILS}`,
    }).then((res) => {
      console.log("Meter supplier :", res);
      if(res&&res.length){
        // const uniqueMeterSuppliers = Array.from(
        //   new Set(res.map((item) => item.meterSupplier))
        // ).map((supplier) => ({
        //   meterSupplier: supplier,
        // }));
        // console.log(uniqueMeterSuppliers);
        setMeterSupplier(res);
      }
    });
  };

  useEffect(() => {
    meterSupplier();
  }, []);

  const getBaudRate = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_BAUDRATE}`,
    }).then((res) => {
      console.log("Baudrate  :", res);
      if(res&&res.length){
        setBaudrate(res);
      }
    });
  };

  useEffect(() => { 
    getBaudRate();
  }, []);
  const getParity = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_PARITY}`,
    }).then((res) => {
      console.log("Parity  :", res);
      if(res&&res.length){
        setParity(res);
      }
    });
  };

  useEffect(() => { 
    getParity();
  }, []);

    const meterdetails = (siteID) => {
    if (!siteID) return;
    console.log(siteID)

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_METER_MODAL_DETAILS}?SupplierID=${siteID.key}`,
    }).then((res) => {
      console.log(res)
      if (res && res.length > 0) {
        setMeterdetails(
          res.map((item) => ({
            modelId: item.modelID,
            modelName: item.modelName,
          }))
        );
      }
    });
  };

  useEffect(() => {
    meterdetails(supplier);
    console.log(supplier)
  }, [supplier]);

    const handleSupplierChange=(value)=>{
    console.log(value)
    form.setFieldsValue({ metermodel: "" })
    setSupplier(value)
  }


const getConverterTypesFromFlags = (record) => {
  const types = [];

  modules.forEach((m) => {
    if (m.moduleName === "Electrical" && record.isElectrical) {
      types.push(m.moduleId);
    }
    if (m.moduleName === "Temperature" && record.isTemperature) {
      types.push(m.moduleId);
    }
    if (m.moduleName === "Air" && record.isAir) {
      types.push(m.moduleId);
    }
    if (m.moduleName === "Steam" && record.isSteam) {
      types.push(m.moduleId);
    }
    if (m.moduleName === "Water" && record.isWater) {
      types.push(m.moduleId);
    }
  });

  return types;
};


const handleEdit = (record) => {
  setIsEditMode(true);
  setEditingRecord(record);
  setDrawerOpen2(true);
  console.log(record)

  const converterTypes = getConverterTypesFromFlags(record);
  console.log(converterTypes)

  form.setFieldsValue({
    converterID: record.siteID,
    converterName: record.siteName,
    converterIP: record.siteIP,
    port: record.port,
    noofPorts: record.noofPorts,
    converterType: converterTypes, // ✅ HERE
    meterSupplier: record.supplier,
    metermodel: record.supplierModel,
    baudrate: record.baudRate,
    parity: record.parity,
  });

  setSupplier(record.supplier);
};


  //console.log(selectedMeterID)
  //console.log(filteredData)
  return (
    <div className="p-4 rounded-xl shadow-md h-screen">
      <div className="mb-5">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
          <span
            level={4}
            className={` ${isdarkMode ? "text-white" : "text-black "}  text-xl  !mb-0`}
          >
            Converters
          </span>
          <Space>
            <Search
              placeholder="Search"
              allowClear
              onSearch={handleSearch}
              style={{ width: 300 }}
            />
            <Button
              disabled={rowData?.length == 0}
              onClick={() => converterExcel(rowData)}
              icon={<FileExcelOutlined />}
            >
              Export Excel
            </Button>
            <Button type="primary" icon={<PlusOutlined />} onClick={openDrawer}>
              Add Converter
            </Button>
          </Space>
        </div>

        <ConverterConfigGrid
  selectedMeterID={selectedMeterID}
  setSelectedMeterID={setSelectedMeterID}
  data={filteredData}
  handleDeleteSubmit={handleDeleteSubmit}
  handleEdit={handleEdit}  
  refetch={refetch}
  setRefetch={setRefetch}
/>


        {/* Right Drawer for Form */}
        <Drawer
          className={` ${isdarkMode ? "my-drawer-body anticon-close" : "#000000"} `}
          // title="Add Converter Details"
          title={
  <div className={`${isdarkMode ? "text-white" : "text-black"}`}>
    {isEditMode ? "Update Converter Details" : "Add Converter Details"}
  </div>
}

          placement="right"
          onClose={closeDrawer}
          open={drawerOpen}
          width={500}
          footer={
            <div className="flex justify-between px-4 py-2">
              <Button onClick={closeDrawer}>Cancel</Button>
              <Button type="primary" onClick={() => form.submit()}>
                Save
              </Button>
            </div>
          }
        >
          <Form layout="vertical" form={form} onFinish={onFinish}>
             <Row gutter={16}>

                     <Col span={12}>
            <Form.Item
              name="converterID"
              // label="Converter ID"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter ID
                </span>
              }
              rules={[{ required: true, message: "Enter converter ID" }]}
            >
              <Input 
              disabled={isEditMode}
                placeholder="Enter converter ID"
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
              />
            </Form.Item>
                     </Col>
                     <Col span={12}>
            <Form.Item
              name="converterName"
              // label="Converter Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter Name
                </span>
              }
              rules={[{ required: true, message: "Enter converter name" }]}
            >
              <Input
                            disabled={isEditMode}
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                placeholder="Enter converter name"
              />
            </Form.Item>
                     </Col>
             </Row>

 <Row gutter={16}>
                     <Col span={12}>
            <Form.Item
              name="converterIP"
              // label="Converter IP"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter IP
                </span>
              }
              rules={[{ required: true, message: "Enter IP address" }]}
            >
              <Input
                placeholder="Enter converter IP"
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
              />
            </Form.Item>
                     </Col>
                     <Col span={12}>
            <Form.Item
              name="port"
              // label="Port"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Port
                </span>
              }
              rules={[{ required: true, message: "Enter port number" }]}
            >
              <Input
                placeholder="Enter port"
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
              />
            </Form.Item>
                     </Col>

 </Row>
 <Row gutter={16}>
                     <Col span={12}>
            <Form.Item
              name="noofPorts"
              // label="No. of Ports"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  No. of Ports
                </span>
              }
              rules={[{ required: true, message: "Enter number of ports" }]}
            >
              <Input
                placeholder="Enter no of ports"
                type="number" 
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
              />
            </Form.Item>
                     </Col>
                     <Col span={12}>
            <Form.Item
              name="converterType"
              // label="Converter Type"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter Type
                </span>
              }
              rules={[{ required: true, message: "Select converter type" }]}
            >
              <Select 
              mode="multiple"
                placeholder="Select converter type"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {modules.map((item) => (
                  <Select.Option
                    mode="multiple"
                    key={item.moduleId}
                    value={item.moduleId}
                  >
                    {item.moduleName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
                     </Col>

 </Row>



               <Row gutter={16}>
                     <Col span={12}>
                      <Form.Item
                        // label="Device Supplier"
                        label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Supplier</span>}
                        name="meterSupplier"
                        rules={[
                          { required: true, message: "Please select device supplier" },
                        ]}
                      >
                        <Select
                          className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
                          dropdownClassName={
                            isdarkMode
                              ? "select-dropdown-background select-dropdown-background-group"
                              : "light-mode-dropdown"
                          }
                          placeholder="Select a device supplier"
                          onChange={handleSupplierChange}
                          value={supplier}
                          labelInValue
                        >
                          {meterSuppliers.map((item) => (
                            <Option key={item.supplierID} value={item.supplierName}>
                              {item.supplierName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        // label="Device Model"
                        label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Model</span>}
                        name="metermodel"
                        rules={[{ required: true, message: "Please select device model" }]}
                      >
                        <Select
                           className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
                          dropdownClassName={
                            isdarkMode
                              ? "select-dropdown-background select-dropdown-background-group"
                              : "light-mode-dropdown"
                          }
                          placeholder="Select Device model"
                          onChange={(value, option) =>
                            form.setFieldsValue({ metermodel: option.children })
                          }
                        >
                          {meterdetail.map((item) => (
                            <Option key={item.modelId} value={item.modelName}>
                              {item.modelName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                   
                  </Row>
               <Row gutter={16}>
                     <Col span={12}>
                      <Form.Item
                        label={<span className={isdarkMode ? "text-white" : "text-black"}>Baurate</span>}
                        name="baudrate"
                        rules={[
                          { required: true, message: "Please select baudrate" },
                        ]}
                      >
                        <Select
                          className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
                          dropdownClassName={
                            isdarkMode
                              ? "select-dropdown-background select-dropdown-background-group"
                              : "light-mode-dropdown"
                          }
                          placeholder="Select a baudrate"
                          // onChange={handleSupplierChange}
                          // value={supplier}
                        >
                          {baudrate.map((item) => (
                            <Option key={item.id} value={item.baudRate}>
                              {item.baudRate}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        // label="Device Model"
                        label={<span className={isdarkMode ? "text-white" : "text-black"}>Parity</span>}
                        name="parity"
                        rules={[{ required: true, message: "Please select parity" }]}
                      >
                        <Select
                           className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
                          dropdownClassName={
                            isdarkMode
                              ? "select-dropdown-background select-dropdown-background-group"
                              : "light-mode-dropdown"
                          }
                          placeholder="Select Parity"
                          // onChange={(value, option) =>
                          //   form.setFieldsValue({ metermodel: option.children })
                          // }
                        >
                          {parity.map((item) => (
                            <Option key={item.id} value={item.parity}>
                              {item.parity}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                   
                  </Row>
          </Form>
        </Drawer>
      </div>
      <div className="">
        <DashMeters selectedSiteID={selectedMeterID} />
      </div>
    </div>
  );
};

export default DashConverters;
